export interface GuideProgress {
  currentSectionId: string | null;
  scrollOffset: number;
  checkboxState: Record<string, boolean>;
}

const STORAGE_PREFIX = "pocket-play.guide.";

function getStorageKey(romBaseName: string): string {
  return `${STORAGE_PREFIX}${romBaseName}`;
}

export function loadProgress(romBaseName: string): GuideProgress {
  const key = getStorageKey(romBaseName);
  try {
    const stored = localStorage.getItem(key);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch {
    // Ignore parse errors
  }

  return {
    currentSectionId: null,
    scrollOffset: 0,
    checkboxState: {},
  };
}

export function saveProgress(romBaseName: string, progress: GuideProgress): void {
  const key = getStorageKey(romBaseName);
  try {
    localStorage.setItem(key, JSON.stringify(progress));
  } catch {
    // Ignore storage errors (quota exceeded, etc.)
  }
}

export function updateCheckbox(
  progress: GuideProgress,
  checkboxIndex: number,
  checked: boolean,
): GuideProgress {
  return {
    ...progress,
    checkboxState: {
      ...progress.checkboxState,
      [checkboxIndex]: checked,
    },
  };
}

export function setCurrentSection(
  progress: GuideProgress,
  sectionId: string | null,
): GuideProgress {
  return {
    ...progress,
    currentSectionId: sectionId,
    scrollOffset: 0,
  };
}

export function setScrollOffset(progress: GuideProgress, offset: number): GuideProgress {
  return {
    ...progress,
    scrollOffset: offset,
  };
}
